import { render, staticRenderFns } from "./VisitLogHistory.vue?vue&type=template&id=37e571f4&"
import script from "./VisitLogHistory.vue?vue&type=script&lang=js&"
export * from "./VisitLogHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports